import React from "react"
import Layout from '../components/layout'

const CoursePage = () => {
  return (
    <Layout>
    <h1> Designing Programs</h1>
    <p><b>Teacher: </b>Mark Webster</p>
    <p><b>Year: </b>2022/23</p>
    <p><b>Syllabus (in French): </b><a href="https://f002.backblazeb2.com/file/ESAD2000/Cours_2021_Pres.pdf"> Download PDF</a></p>
    <h2>Description</h2>
    <p>
    Designing Programs is a condensed, pedagogical course to computer programming for higher education 
    students working in the visual arts. It serves both as a means for learning how to program and for 
    understanding how the medium of code can be used in the creative process. It follows a structured 
    and methodological approach to acquiring the fundamental concepts as well as giving time for the student to explore practical applications in line with the field of graphic design.
    </p>
    <h2></h2>
    <p>
      The course is therefore concerned with learning a medium and a media, software and code at large. To accomplish
      this, students follow a first semester learning the fundamental concepts of programming with Processing. A 
      variety of exercises may be given on topics such as computational manipulation of point, line & surface; image,
      time & motion. Sometimes a specific project is given too. The idea is to both acquire the technical side as well as understand plausible applications of 
      the medium. 
    </p>

    <h2></h2>
    <p>
      In the second semester, the student takes this knowledge further and within the context of a specific topic. The topic 
      is usually general enough for the student to express a personal approach all the while giving a means for 
      him/her to consolidate their studies in the field. 
    </p>

    <h2>Objectives</h2>
    <p>
      There are two main objectives for this course. Firstly, the student is to explore the medium of code  and within the context of artistic expression. Secondly, the student works on a personal project
      that implements code as a medium. In general, a topic is given and students are asked to develop their
      ideas around this topic. Throughout the course, the student is encouraged to question contemporary issues in line with their practise as an artist/designer at large and specifically aimed at computational design. Typical issues include generative art/design, interactive systems, data, artificial intelligence but these are non-exclusive. 
    </p>

    <h2>Required & Tools </h2>
    <p>
      <li><a href="https://www.processing.org/download/"> Processing </a>on a laptop computer.</li>
      <li><a href="#">Discord/Element</a> - Keeping in touch during the course :–)</li>
      <li><a href="https://designingprograms.bitbucket.io/"> Designing Programs online course.</a></li>
    </p>
    <h2></h2>
    <p></p>
    </Layout>
  )
}

export default CoursePage
